<template>
  <div>
    <div class="pay">
      <img class="bg1 bg" src="../assets/bg1.png" alt="">
      <img class="bg2 bg" src="../assets/bg2.png" alt="">
      <div class="body_div_pay">
        <div class="head_div">
          <img class="fr head_div_img" @click="refresh()" src="../assets/ring.png" alt="">
          <div class="head_divtext fr" @click="showex()">CGM Pay国际支付？</div>
        </div>
        <div class="paytype">
          <div class="paytype_top">
            <div class="paytype_item on">
              <img src="../assets/xj.png" alt="">
              <span>现金支付</span>
            </div>
            <div class="paytype_item">
              <img src="../assets/jf.png" alt="">
              <span>积分支付</span>
            </div>
          </div>
          <div class="paytype_cardbox">
            <div class="paytype_card">
              <img class="paytype_cardself" src="../assets/card.png" alt="">
              <div class="paytype_ma" @click="showpay()">
                <div class="paytype_matxt">代付</div>
                <img src="../assets/ma.png" alt="">
              </div>
              <div class="pay_explain" v-show="payma">
                <div class="mask"></div>
                <div class="pay_explain_content">
                  <img class="pay_explain_close" @click="hidepay()" src="../assets/close.png" alt="">
                  <div class="pay_explain_box">
                    <img class="hcode" src="../assets/hcode.png" alt="">
                    <div class="manumber">3158 9926 50526595 020</div>
                    <!-- <img class="rcode" src="../assets/code.png" alt=""> -->
                    <div v-show="paySelect == 3" id="unionpay" class="rcode" ref="unionpay"></div>
                    <div v-show="paySelect == 2" id="wechatpay" class="rcode" ref="wechatpay"></div>
                    <div class="pay_lr">
                      <img class="paylogo fl" src="../assets/malogo.png" alt="">
                      <div class="fr fresh_right">
                        <img @click="freshtime()" class="fresh" src="../assets/fresh.png" alt="">
                        <span class="freshtime" v-if="nowtime">{{ nowtime }}</span>
                      </div>
                    </div>
                    <div class="attention">
                      <img class="attentionimg" src="../assets/attention.png" alt="">
                      如出现失效的情况，请进行刷新
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="paytype_three" v-show="payStatus == 0">
            <div class="paytype_chose" :class="{ 'on': paySelect==2 }" @click="chageWechat()">
              <div class="recommend">
                <img src="../assets/recommend.png" alt="">
                <span>推荐支付 便捷</span>
              </div>
              <img class="default" src="../assets/wx.png" alt="">
              <img class="on" src="../assets/wx_on.png" alt="">
              <span>微信</span>
            </div>
            <div class="paytype_chose" :class="{ 'on': paySelect==1 }" @click="chageAlipay()">
              <img class="default" src="../assets/zfb.png" alt="">
              <img class="on" src="../assets/zfb_on.png" alt="">
              <span>支付宝</span>
            </div>
            <div class="paytype_chose" :class="{ 'on': paySelect==3 }" @click="chageUnionPay()">
              <img class="default" src="../assets/yl.png" alt="">
              <img class="on" src="../assets/yl_on.png" alt="">
              <span>银联</span>
            </div>
          </div>
          <div class="paytype_three payedstatus" v-show="payStatus == 1">
            <div class="paytype_chose">
              <img class="default" src="../assets/wxno.png" alt="">
              <span>微信</span>
            </div>
            <div class="paytype_chose">
              <img class="default" src="../assets/zfbno.png" alt="">
              <span>支付宝</span>
            </div>
            <div class="paytype_chose">
              <img class="default" src="../assets/ylno.png" alt="">
              <span>银联</span>
            </div>
          </div>
          <div class="paytype_three">
            <div class="paytime">
              <img class="paytimeimg" src="../assets/pay.png" alt="">
              <div class="paytimetit">总计支付金额</div>
              <div class="payed" v-show="payStatus == 1">已支付</div>
              <!--             <div class="payed" v-if="payStatus == 1" @click="createBook()">生成領収書</div>-->
              <div class="paytimettext" v-show="payStatus == 0">截止支付日期：请在24小时内进行支付</div>
            </div>
            <div class="paynum">
              <div class="paynumbox fl" v-if="orderData.realAmountLast">{{ orderData.realAmountLast }}
                <div class="paynumjpy">JPY</div>
              </div>
              <div class="paynumbox fl" v-else>{{ orderData.realAmount }}
                <div class="paynumjpy">JPY</div>
              </div>
            </div>
            <div style="display: flex;gap: 20px">
              <div class="paynumdetail" v-if="!isHideDetailButton" @click="showdetail()">查看明细</div>
              <!--              <div class="paynumdetail" v-if="payStatus == 1" @click="createBook()">生成領収書</div>-->
            </div>
            <div class="content_bottom_div_pay" v-show="payStatus == 1">
              <div class="order_payitem_pay">
                <div class="wuliu_style">
                  <img class="freight" src="../assets/freight.png" alt="">
                  <span>{{ orderData.expressName }} :</span> <span class="wuliu_style_span">{{
                    orderData.expressNum
                  }}</span>
                  <img class="copy" v-copy="orderData.expressNum" @click="copyEXNum()" src="../assets/copy.png" alt="">
                  <!-- <el-button v-copy="orderData.expressNum" @click="copyEXNum()">复制单号</el-button> -->
                </div>
                <div class="block">
                  <el-timeline :reverse="reverse">
                    <el-timeline-item v-for="(activity, index) in activities" :key="index"
                                      :timestamp="activity.timestamp" :icon="activity.icon">
                      {{ activity.content }}
                    </el-timeline-item>
                  </el-timeline>
                </div>
              </div>
            </div>
          </div>
          <div class="address">
            <div class="address_name">收件人：{{ orderData.recipientName }}</div>
            <div class="address_name">收货电话：{{ orderData.recipientTelephone }}</div>
            <div class="address_name">收货地址：{{ orderData.recipientProvince }}{{
                orderData.recipientCity
              }}{{ orderData.recipientDistrict }}{{
                orderData.recipientAddress
              }}
            </div>
          </div>
          <div class="paybtn" v-show="payStatus == 0" @click="goPay()">确认支付</div>
          <div class="paybtn payedstatus" v-show="payStatus == 1">确认支付</div>
          <!--          <div class="paytype_three">-->
          <!--            <div class="another">-->
          <!--              <img src="../assets/another.png" alt="">-->
          <!--              CGM GROUP其他服务-->
          <!--            </div>-->
          <!--          </div>-->
          <!--          <div class="another_item" @click="gocgmgroup()">-->
          <!--            <img class="another_itemimg" src="../assets/antherimg1.png" alt="">-->
          <!--            <div class="another_right">-->
          <!--              <div class="another_tit">CGM制药 - 家庭配置药</div>-->
          <!--              <div class="another_desc">为全世界的家庭提供家庭用药服务</div>-->
          <!--              <div class="another_desc">・过期免费更换</div>-->
          <!--              <div class="another_desc">・家庭医生24小时服务</div>-->
          <!--            </div>-->
          <!--          </div>-->
          <!--          <div class="another_item" @click="gomedical()">-->
          <!--            <img class="another_itemimg" src="../assets/antherimg2.png" alt="">-->
          <!--            <div class="another_right">-->
          <!--              <div class="another_tit">CGM Medical - 国际线上处方平台</div>-->
          <!--              <div class="another_desc">加速推进全球医药品的合法流通</div>-->
          <!--              <div class="another_desc">・日本医生在线开处方</div>-->
          <!--              <div class="another_desc">・国际配送 报关 符合中国法律</div>-->
          <!--              <div class="another_desc">・医生处方 安全可靠</div>-->
          <!--            </div>-->
          <!--          </div>-->
          <!--          <div class="another_item">-->
          <!--            <img class="another_itemimg" src="../assets/antherimg3.png" alt="">-->
          <!--            <div class="another_right">-->
          <!--              <div class="another_tit">CGM制药 ✖️ 营养所</div>-->
          <!--              <div class="another_desc">为全世界提供私人订制营养品</div>-->
          <!--              <div class="another_desc">・AI分析个人体检报告搭配所需营养品</div>-->
          <!--              <div class="another_desc">・基础尿检精准确定身体所缺少的营养</div>-->
          <!--              <div class="another_desc">・顺天堂教授搭配安全可靠</div>-->
          <!--            </div>-->
          <!--          </div>-->
          <div class="copyright">©CGM Group All Rights Reserved.</div>
          <div class="pay_explain" v-show="showexplain">
            <div class="mask"></div>
            <div class="pay_explain_content">
              <img class="pay_explain_close" @click="hideexplain()" src="../assets/close.png" alt="">
              <div class="pay_explain_box">
                <div class="payexplain_tit">CGM Pay国际支付</div>
                <div class="payexplain_txt">日本CGM集团所控股的国际第三方支付公司、面向中国地区的用户CGM
                  Pay已经链接了中国主流支付（微信、支付宝、银联）
                </div>
                <div class="payexplain_txt">用户可以选择支付方式向CGM Pay进行付款、付款时主流支付公司会自动按照当日汇率进行换汇。
                  根据中华人民共和国国际支付法律规定：1个人30日内不可超过3万元。
                </div>
              </div>
            </div>
          </div>
          <div class="pay_explain detail" v-show="detail">
            <div class="mask"></div>
            <div class="pay_explain_content">
              <img class="pay_explain_close" @click="hidedetail()" src="../assets/close.png" alt="">
              <div class="pay_explain_box">
                <div class="order_line_pay">
                  <div class="order_left_pay">商品金额</div>
                  <div class="order_right_pay">{{ orderData.goodsPriceSum }} JPY</div>
                </div>
                <div class="order_line_pay" v-for="(item, index) in medicinelist" :key="index">
                  <div class="order_left_pay on">{{ item.casualName }}</div>
                  <div class="order_right_pay">{{ item.price }} JPY x{{ item.quantity }}</div>
                </div>
                <div class="order_line_pay">
                  <div class="order_left_pay">服务项金额</div>
                  <div class="order_right_pay">{{ orderData.serviceItemPriceSum }} JPY</div>
                </div>
                <div class="order_line_pay">
                  <div class="order_left_pay">运费</div>
                  <div class="order_right_pay">{{ orderData.transportPrice }} JPY</div>
                </div>
                <div class="order_line_pay"
                     v-if="orderData.serviceFeeFlag === 1">
                  <div class="order_left_pay">国际支付手续费</div>
                  <div class="order_right_pay">{{ orderData.taxPrice }} JPY</div>
                </div>
                <div class="order_line_pay">
                  <div class="order_left_pay">实付</div>
                  <div class="order_right_pay">{{ orderData.realAmount }} JPY</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


  </div>

</template>
<script>
import QRCode from 'qrcodejs2'

export default {
  name: '',
  components: {
    QRCode
  },
  mixins: [],
  props: {},
  data() {
    return {
      orderData: {
        soHeadId: null,
        recipientName: null,
        recipientTelephone: null,
        recipientAddress: null,
        goodsPriceSum: null,
        serviceItemPriceSum: null,
        transportPrice: null,
        serviceFeeFlag: null,
        taxPrice: null,
        realAmount: null,
        expressNum: null,
        soPayment: null,
        recipientProvince: null,
        recipientCity: null,
        recipientDistrict: null,
        soHeadCode: null
      },
      paySelect: "0",
      payStatus: null,
      reverse: false,
      activeName: '1',
      activities: [],
      orderNumber: null,
      showexplain: false,
      payma: false,
      detail: false,
      medicinelist: [],
      nowtime: undefined
    };
  },
  computed: {
    isHideDetailButton() {
      return this.orderData.soType === 'SOTYPE08';
    }
  },
  watch: {},

  mounted() {
    const orderNumber = this.$route.query.oderNumber;
    this.orderNumber = orderNumber;

    const loading = this.$loading({
      lock: true,
      text: '订单加载中...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });

    this.axios.get('/nihaopay/getOrderInfo/' + orderNumber, {
    }).then((response) => {
      let orderDataAll = response.data.data.data;
      this.orderData = orderDataAll
      this.payStatus = orderDataAll.soCollection;
      this.medicinelist = orderDataAll.lineList;

      if(orderDataAll.expressNum){
        this.axios.get('/nihaopay/track/' + orderDataAll.expressNum, {
        }).then((response) => {
          if(response && response.data){
            let trackData = response.data.data.data;
            var newActivity;
            for(var i in trackData){
              newActivity = {
                content: trackData[i ].context,
                timestamp: trackData[i ].time,
                icon: 'el-icon-freight'
              };
              if(i == 0){
                newActivity.icon = 'el-icon-now'
              }
              this.activities.push(newActivity)
            }
          }
        }).catch(() => {
          loading.close();
        });
      }
      loading.close();
    }).catch(() => {
      loading.close();
    });
  },
  methods: {
    qrcodeScan(text, codebox) { //生成二维码
      let qrcode = new QRCode(document.getElementById(codebox), {
        width: 108, // 二维码宽度
        height: 108, // 二维码高度
        text: text, // 浏览器地址url
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H,
      })
    },
    freshtime() {
      this.$refs.unionpay.innerHTML = ""
      this.$refs.wechatpay.innerHTML = ""
      this.payma = false;
      this.showpay()
    },
    refresh() {
      this.$router.go(0);
    },
    hidedetail() {
      this.detail = false;
    },
    showdetail() {
      this.detail = true;
    },
    hidepay() {
      this.$refs.unionpay.innerHTML = ""
      this.$refs.wechatpay.innerHTML = ""
      this.payma = false;
    },
    showpay() {

      // 二维码接口wechatpay alipay unionpay
      var paytype1;
      const orderNumber = this.$route.query.oderNumber;
      if (this.paySelect == "0") {
        this.$message({
          message: '请选择支付方式',
          type: 'warning'
        });
        return;
      } else if (this.paySelect == "2") {
        paytype1 = 'wechatpay'
      } else if (this.paySelect == "3") {
        paytype1 = 'unionpay'
      } else if (this.paySelect == "1") {
        this.$message({
          message: '暂时不支持支付宝代付',
          type: 'warning'
        });
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: '加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.axios.get('/nihaopay/qrPay?orderId=' + orderNumber + '&payType=' + paytype1, {}).then((response) => {
        //  console.log(response.data.code)
        if (response.data.code == 200) {
          this.qrcodeScan(response.data.data.result, paytype1)
          setTimeout(() => {
            loading.close();
          }, 100);
          this.nowtime = new Date().toLocaleTimeString();
        }
        this.payma = true;
      })
    },
    showex() {
      this.showexplain = true;
    },
    hideexplain() {
      this.showexplain = false;
    },
    chageAlipay() {
      this.paySelect = "1";
    },

    chageWechat() {
      this.paySelect = "2";
    },

    chageUnionPay() {
      this.paySelect = "3";
    },
    copyEXNum() {
      this.$message({
        message: '复制成功',
        type: 'success'
      });
    },

    goPay() {
      if (this.paySelect === "0") {
        this.$message({
          message: '请选择支付方式',
          type: 'warning'
        });
        return;
      }

      const payTypeMap = {
        "1": "alipay",
        "2": "wechatpay",
        "3": "unionpay"
      };
      const payType = payTypeMap[this.paySelect];

      if (!payType) {
        this.$message({
          message: '未知的支付方式',
          type: 'error'
        });
        return;
      }

      const loading = this.$loading({
        lock: true,
        text: '支付请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      this.axios.get('/nihaopay/securePay', {
        params: {
          orderId: this.orderNumber,
          payType
        }
      }).then((response) => {
        console.log(response);
        if (response.data.code != 200) {
          this.$message({
            message: response.data.message,
            type: 'error'
          });
        } else {
          // 检查响应数据是否存在
          if (response.data && response.data.data && response.data.data.data) {
            let w = window.open("", "_self");
            w.document.write(response.data.data.data);
          } else {
            this.$message({
              message: '支付响应数据格式错误',
              type: 'error'
            });
          }
        }
      }).catch((error) => {
        this.$message({
          message: '支付请求失败，请稍后重试',
          type: 'error'
        });
        console.error(error);
      }).finally(() => {
        loading.close();
        this.paySelect = "0";
      });
    }
  }
};
</script>
<style lang='scss' scoped>

.wuliu_style {
  margin-bottom: 24px;
}

.wuliu_style span {
  font-size: 14px;
}

.noPay {

  width: 100vw;
  background-color: #535e7c;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pay {
  width: 100vw;
  background-color: #1E7ACA;
  display: flex;
  justify-content: center;
}

.bg {
  position: absolute;
}

.bg1 {
  width: 80%;
  top: 0;
  left: 0;
}

.bg2 {
  width: 50%;
  top: 60px;
  right: 0;
}

.body_div {
  width: 98vw;
}

.body_div_pay {
  position: relative;
  z-index: 1;
  margin-top: 20px;
  width: 94vw;
}

.head_div {
  height: 22px;
  margin: 10px 20px 25px 0;
}

.fr {
  float: right;
}

.head_divtext {
  text-align: center;
  width: 103px;
  height: 22px;
  border-radius: 11px;
  border: 1px solid #fff;
  color: #fff;
  font-size: 10px;
  line-height: 22px;
}

.head_div_img {
  width: 18px;
  margin-left: 9px;
  margin-top: 3px;
  display: block;
}

.content_div {
  width: 100%;
  background-color: white;
  border-radius: 4px;
  margin-top: 19px;
  padding: 20px 15px 20px 15px;
  box-sizing: border-box;
  /* 关键属性 */

}

.content_div_pay {
  width: 100%;
  background-color: white;
  border-radius: 4px;
  margin-top: 19px;
  padding: 20px 15px 20px 15px;
  box-sizing: border-box;
  /* 关键属性 */

}

.content_bottom_div {
  width: 100%;
  background-color: white;
  border-radius: 4px;
  margin-top: 15px;
  padding: 20px 15px 20px 15px;
  box-sizing: border-box;
  /* 关键属性 */
}

.content_bottom_div_pay {
  width: 100%;
  // background-color: white;
  border-radius: 4px;
  margin-top: 15px;
  // padding: 20px 15px 20px 15px;
  box-sizing: border-box;
  overflow: auto;
  color: #fff;
}


.order_price {
  font-size: 30px;
  color: #313131;
  font-weight: bold;
}

.order_paydate {
  font-size: 12px;
  color: #fff;
  margin-bottom: 28px;
}

.order_payname {
  margin-left: 15px;
  display: inline-block;
  border-radius: 2px;
  background: #F6E2E0;
  font-size: 12px;
  color: #D36364;
  padding: 1px 2px;
}


.order_list {
  font-size: 0;
  margin-bottom: 12.5px;
  display: flex;
  flex-direction: column;
}

.order_left {
  display: inline-block;
  width: 55px;
  text-align-last: justify;
  font-size: 12px;
  color: #9C9C9C;
  margin-right: 22.5px;
}

.order_right {
  display: inline-block;
  font-size: 12px;
  color: #4B4B4B;
}

.order_line {
  margin-bottom: 15px;
}

.order_payitem {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
}

// .order_payitem_pay {
//   margin-bottom: 15px;
// }
.el-timeline {
  font-size: 17px;
}

.order_payitem_but {
  height: 35px;
  width: 30%;
  display: flex;
  align-items: center;
  justify-content: center;

}

.order_payitem_main_but {
  width: 100%;
  height: 45px;
  font-weight: bold;
  font-size: 18px;
  background-color: #3173ca;
}

.order_payitem_img {
  width: 80px;
}

.order_payitem_bottom_pay {
  font-size: 12px;
  line-height: 18px;
  color: #9C9C9C;
  width: 100%;
  background-color: white;
  border-radius: 4px;
  margin-top: 15px;
  padding: 20px 15px 20px 15px;
  box-sizing: border-box;
}

.order_payitem_bottom {
  font-size: 12px;
  line-height: 18px;
  color: #9C9C9C;
}

.log_bottom {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 15px;
}

.log_bottom_font {
  font-size: 12px;
  color: #fff;
}

.order_status {
  font-size: 24px;
  color: #109045;
  margin-bottom: 17px;
}

.order_line_pay {
  margin-bottom: 15px;
  display: flex;
  justify-content: space-between;

}

.order_left_pay {
  font-size: 12px;
}

.order_left_pay.on {
  padding-left: 15px;
}

.order_right_pay {

  font-size: 14px;
  color: #4B4B4B;
}


.order_right_pay_bottom {
  font-size: 12px;
}


.order_line_pay_split {
  border-top: 1px solid #DCDCDC;
  margin-bottom: 15px;
}

// 新版
.paytype_top {
  font-size: 0;
  width: 70%;
  margin: 0 auto 24px;
}

.paytype_item {
  width: 50%;
  text-align: center;
  display: inline-block;
}

.paytype_item img {
  vertical-align: middle;
  width: 20px;
  margin: -11px 10px 0 0;
}

.paytype_item:nth-child(2) img {
  width: 16px;
}

.paytype_item span {
  font-size: 16px;
  color: #D5D4D4;
  position: relative;
}

.paytype_item.on span {
  color: #fff;
}

.paytype_item.on span::after {
  content: '';
  position: absolute;
  width: 60px;
  height: 3px;
  border-radius: 1px;
  background: #fff;
  left: 0;
  bottom: -6px;
}

.paytype_card {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  margin-bottom: 21px;
}

.paytype_cardself {
  flex: 1;
  width: 279px;
}

.paytype_ma {
  width: 74px;
  margin-left: 8px;
  padding: 9px;
  box-sizing: border-box;
  background: #fff;
  border-radius: 5px;
}

.paytype_matxt {
  font-size: 12px;
  text-align: center;
  margin-bottom: 5px;
}

.paytype_ma img {
  width: 100%;
}

.paytype_three {
  width: 92%;
  margin: 0 auto;
}

.paytype_chose {
  position: relative;
  display: inline-block;
  width: 48%;
  height: 40px;
  line-height: 40px;
  border-radius: 18px;
  background: #fff;
  text-align: center;
  margin-bottom: 14px;
}

.paytype_chose:nth-child(2n+1) {
  margin-right: 4%;
}

.paytype_chose:nth-child(3) img {
  width: 25px;
}

.paytype_chose img {
  display: inline-block;
  width: 22px;
  margin-right: 9px;
  vertical-align: middle;
}

.paytype_chose.on {
  background: #1161BA;
}

.paytype_chose.on img.default {
  display: none;
}

.paytype_chose.on img.on {
  display: inline-block;
}

.paytype_chose img.on {
  display: none;
}

.paytype_chose img.default {
  display: inline-block;
}

.paytype_chose span {
  font-size: 16px;
  color: #0B308E;
}

.paytype_chose.on span {
  color: #fff;
}

.recommend {
  position: absolute;
  top: -41px;
  left: 0;
  right: 0;
  margin: auto;
  width: 102px;
  height: 35px;
}

.recommend img {
  width: 100%;
}

.recommend span {
  color: #fff;
  position: absolute;
  left: 0;
  right: 0;
  top: 0px;
  font-size: 12px;
}

.paytime {
  color: #fff;
}

.paytime div {
  display: inline-block
}

.paytimeimg {
  display: inline-block;
  vertical-align: middle;
  width: 19px;
  margin-right: 6px;
}

.paytimetit {
  margin-right: 17px;
  font-size: 14px;
}

.paytimettext {
  font-size: 12px;
}

.paynum {
  margin: 20px 0;
  height: 30px;
}

.fr {
  float: right;
}

.fl {
  float: left;
}

.paynumbox {
  color: #fff;
  font-size: 30px;

}

.paynumjpy {
  display: inline-block;
  font-size: 20px;
}

.paynumdetail {
  font-size: 14px;
  color: #0B308E;
  width: 81px;
  height: 28px;
  line-height: 28px;
  border-radius: 14px;
  text-align: center;
  //margin-top: 5px;
  margin-bottom: 20px;
  background-color: #fff;
}

.freight {
  width: 17px;
  vertical-align: middle;
  margin-right: 5px;
}

.copy {
  vertical-align: middle;
  width: 14px;
  margin-left: 5px;
}

::v-deep .el-icon-freight {
  background: url('../assets/timeline.png') center center no-repeat;
  background-size: 20px;
  width: 20px;
  height: 20px;
}

::v-deep .el-icon-now {
  background: url('../assets/now.png') center center no-repeat;
  background-size: 20px;
  width: 20px;
  height: 20px;
}

::v-deep .el-timeline-item__content {
  color: #fff;
  font-size: 14px;
}

::v-deep .el-timeline-item__timestamp.is-bottom {
  color: #fff;
  font-size: 12px;
}

::v-deep .el-timeline-item__node--normal {
  width: 20px;
  height: 20px;
  background: transparent;
}

::v-deep .el-timeline-item__tail {
  left: 7px;
  top: 20px;
  height: calc(100% - 20px);
}

.address {
  background: #134DA4;
  border-radius: 10px;
  padding: 10px 20px;
}

.address_name {
  font-size: 12px;
  color: #fff;
  line-height: 30px;
}

.paybtn {
  margin: 18px 0 20px;
  width: 100%;
  height: 45px;
  line-height: 45px;
  border-radius: 23px;
  background: #fff;
  font-size: 16px;
  color: #1161BA;
  text-align: center;
}

.another {
  font-size: 14px;
  color: #fff;
  margin-bottom: 16px;
}

.another img {
  width: 13px;
  margin-right: 8px;
  vertical-align: top;
  margin-top: 3px;
}

.another_item {
  background: #fff;
  border-radius: 10px;
  display: flex;
  padding: 10px;
  margin-bottom: 12px;
  align-items: center;
}

.another_itemimg {
  width: 115px;
  margin-right: 15px;
}

.another_right {
  flex: 1;
  width: 270px;
}

.another_tit {
  font-size: 15px;
  line-height: 28px;
}

.another_desc {
  line-height: 2;
  font-size: 12px;
}

.copyright {
  margin: 23px auto 40px;
  font-size: 14px;
  color: #fff;
  text-align: center;
}

.pay_explain {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.mask {
  position: absolute;
  background: rgba(0, 0, 0, .3);
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.pay_explain_content {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  height: 278px;
  width: 94vw;
  margin: auto;
  padding: 15px 18px;
  box-sizing: border-box;
  background: #fff;
  z-index: 10;
  border-radius: 10px;
}

.pay_explain_close {
  position: absolute;
  width: 16px;
  top: 10px;
  right: 11px;
  z-index: 1;
}

.payexplain_tit {
  font-size: 16px;
  text-align: center;
  margin-bottom: 12px;
}

.payexplain_txt {
  font-size: 14px;
  line-height: 30px;
}

.paytype_card .pay_explain {
  z-index: 1;
}

.paytype_card .pay_explain_content {
  top: 122px;
  bottom: auto;
  height: 305px;
  padding: 30px 0 0;
}

.manumber {
  font-size: 12px;
  color: #0B308E;
  letter-spacing: 2px;
  text-align: center;
  height: 30px;
  line-height: 30px;
  margin: 5px 0;
}

.paytype_cardbox {
  position: relative;
}

.hcode {
  width: 75%;
  display: block;
  margin: 0 auto;
}

.rcode {
  width: 108px;
  display: block;
  margin: 0 auto 4px;
}

.pay_lr {
  width: 94%;
  margin: 0 auto 8px;
  height: 27px;
}

.paylogo {
  width: 94px;
}

.fresh {
  width: 18px;
  vertical-align: middle;
  margin-right: 5px;
}

.freshtime {
  font-size: 12px;
  color: #0B308E;
}

.attention {
  width: 94%;
  margin: 0 auto;
  padding-top: 10px;
  font-size: 12px;
  letter-spacing: 5px;
  border-top: 1px dashed #D5D3D3;
}

.attentionimg {
  width: 20px;
  margin-left: 5px;
  margin-top: -5px;
  vertical-align: middle;
  display: inline-block;
}

.detail .pay_explain_content {
  padding: 40px 15px 20px;
  height: auto;
  top: 220px;
  bottom: auto;
}

.payed {
  background: #00B0EF;
  border-radius: 2px 10px;
  font-size: 12px;
  color: #fff;
  text-align: center;
  width: 64px;
  height: 22px;
  line-height: 22px;
  margin-right: 10px;
}

.payedstatus .paytype_chose {
  background: #B5B5B5;
}

.payedstatus .paytype_chose span {
  color: rgba(0, 0, 0, .5);
}

.payedstatus.paybtn {
  background: #B5B5B5;
  color: rgba(0, 0, 0, .5);
}
</style>
